interface IGetOrderProcessingTextParams {
  isCashPayment: boolean;
}
export const getOrderProcessingText = ({ isCashPayment }: IGetOrderProcessingTextParams) => {
  return isCashPayment ? 'orderProcessingDisclaimerCashPayment' : 'orderProcessingDisclaimer';
};
